import { Component } from 'react';
import { Container } from 'reactstrap';
import authService from './api-authorization/AuthorizeService'
import { NavMenu } from './NavMenu';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { LOCALES } from "./../translations/locales";
import { messages } from "./../translations/messages";
import { CookieMessage } from './CookieMessage';
import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

export class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: LOCALES.RUSSIAN,
    };
  }

  selectLanguage(e, language) {
    e.preventDefault();
    this.setState(prevState => ({...prevState, locale: language}));
  }

  async createOrder(resourceId, time, serviceId, date, price) {
    if (this.state.colorchange || !serviceId) {
      return;
    }
    this.setState(prevState => ({...prevState, colorchange: true}));
    setTimeout(async ()=> {
      const startTime = Date.now();
      const token = await authService.getAccessToken();

      var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
      date = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
      const response = await fetch(`{{mainApiUrl}}api/orders`, {
        method: "POST",
        headers: {
          ...headers,
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ serviceId: serviceId, resourceId: resourceId, start: time, end: time + Math.floor(this.state.duration)*100 + this.state.duration*100%100*0.6, date: date, userPhone: this.state.phone, userName: this.state.userName, partialBooking: this.state.partialBooking, partialBookingText: this.state.partialBookingText, orderParams: this.state.orderParams.map(op => op.id), delivery: this.state.delivery, price: price })
      });
      if (!response.ok) {
        this.setState(prevState => ({...prevState, colorchange: undefined, errorBooking: "Бронирование не подтверждено"}));
        return;
      }
      const data = await response.json();
      data.date = date;
      //this.setState(prevState => ({...prevState, orders: [...prevState.orders, data]}));
      await this.populateCalendarData(true);

      const remainingTime = 3000 - (Date.now() - startTime);
      setTimeout(() => {
        this.setState(prevState => ({...prevState, orders: this.state.temporders, temporders: null, phone: '+7', userName: '', partialBooking: null, partialBookingText: '', colorchange: undefined, errorBooking: undefined, newbooking: undefined}));
        if (this.state.selectedTime)
          this.setState(prevState => ({...prevState, filteredTimes: [...this.state.filteredTimes, data]}));
      }, remainingTime > 0 ? remainingTime : 0);
    }, 0);
  }

  async registerNativePush() {
    const token = await authService.getAccessToken();
    if (!token) {
      return;
    }
    // Request permissions (iOS prompts user, Android grants automatically)
    const permStatus = await PushNotifications.requestPermissions();
  
    if (permStatus.receive === 'granted') {
      // Register with APNS/FCM
      await PushNotifications.register();
    } else {
      console.log('Permission denied');
      return;
      // Handle permission denial
    }

    // Get the device token (FCM or APNs) to send to your server
    await PushNotifications.addListener('registration', async pushToken => {
      console.log('Native Token:', pushToken.value);
      var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
      const response = await fetch(`{{mainApiUrl}}api/push/register`, {
        method: "POST",
        headers: {
          ...headers,
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({token: pushToken.value, platform: Capacitor.getPlatform()})
      });
      // Send this token.value to your backend
    });

    await PushNotifications.addListener('registrationError', err => {
      console.error('Registration error:', err.error);
    });

    // Listen for notifications received while app is open
    await PushNotifications.addListener('pushNotificationReceived', notification => {
      console.log('Notification received', notification);
    });

    // Listen when user taps the notification
    await PushNotifications.addListener('pushNotificationActionPerformed', notification => {
      console.log('Action performed', notification);
    });
  }

  async registerWebPush() {
    const token = await authService.getAccessToken();
    if (!token) {
      return;
    }

    if ('serviceWorker' in navigator && 'PushManager' in window) {
      // Register the service worker
      const registration = await navigator.serviceWorker.register('/sw.js');
    
      // Request permission & subscribe
      const subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: 'BCmd4VDdDnaHbXxS8wFpJdS80mZUpK-E_BXXRWkk2hbdCPhD4Y5i_p4J6IoLKRzlI6rtTzIQxXPWutX9OjB3ZJU'
      });
    
      // Send subscription object (not just a string token) to your backend
      console.log('Web Push Subscription:', subscription);

      var headers = !token ? {} : { 'Authorization': `Bearer ${token}` };
      const response = await fetch(`{{mainApiUrl}}api/push/register`, {
        method: "POST",
        headers: {
          ...headers,
          'Accept': 'application/json, text/plain',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({...subscription.toJSON(), platform: "web"})
      });
      if (!response.ok) {
        console.warn('Push was not registered on the server');
      }
    } else {
      console.warn('Push not supported in this browser');
    }
  }

  render () {
    if (Capacitor.isNativePlatform()) {
      // It's running on iOS or Android
      this.registerNativePush();
    } else {
      // It's running in a browser (as a PWA)
      this.registerWebPush();
    }
    return (
      <IntlProvider messages={messages[this.state.locale]} locale={this.state.locale} defaultLocale={LOCALES.ENGLISH}>
        <CookieMessage/>
        <div class="layout">
          <NavMenu />
          <Container className="maincont">
            {this.props.children}
          </Container>
          <div class="footer border-top text-muted">
            <div class="container">
              &copy; 2026 - Planna - <a href="/privacy"><FormattedMessage id="policy"/></a> <a href="" onClick={(e) => this.selectLanguage(e, LOCALES.ENGLISH)}>EN</a> <a href="" onClick={(e)=>this.selectLanguage(e, LOCALES.RUSSIAN)}>RU</a>
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}